export const vertexShader = `
  varying vec2 vUv;
  varying vec3 vPosition;
  void main() {
    vUv = uv;
    vPosition = position;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const fragmentShader = `
  uniform float time;
  uniform float transition;
  uniform vec3 gradientX;
  uniform vec3 gradientY;
  uniform vec3 gradientZ;
  uniform vec4 iridescentVal;
  uniform vec2 iridescentVal2;
  uniform float iridescentSpeed;
  varying vec3 vPosition;
  varying vec2 vUv;

  #define rot(p,a) vec2 sc=sin(vec2(a,a+1.6)); p*=mat2(sc.y,-sc.x,sc);
  #define A vec3(0,1,157)
  #define B {vec2 m=fract(p),l=dot(p-m,A.yz)+A.xz,r=mix(fract(57.*sin(l++)),fract(57.*sin(l)),(m*=m*(3.-m-m)).x);color+=mix(r.x,r.y,m.y)/(s+=s);p*=mat2(1,1,1,-1);}

float random( vec2 p )
{
  vec2 K1 = vec2(
    23.14069263277926, // e^pi (Gelfond's constant)
    2.665144142690225 // 2^sqrt(2) (Gelfond–Schneider constant)
  );
return fract( cos( dot(p,K1) ) * 12345.6789 );
}

  void main() {

    float newTime = time * iridescentSpeed;
    vec2 p = (normalize(vPosition) * 0.5 + 0.5).xy;
    rot(p, newTime / iridescentVal2.x);	// slow field rotation

    float s = 1.0;
    vec4 color = vec4(0);
    B B B B // unrolled perlin noise see https://www.shadertoy.com/view/lt3GWn
    color += sin(iridescentVal.x * sin(color * iridescentVal.y + newTime * iridescentVal.z) + p.yxyy-p.yyxy * iridescentVal.w) / iridescentVal2.y; // colour transform
    color.r = clamp(color.r, 0.0, 1.0);
    color.g = clamp(color.g, 0.0, 1.0);
    color.b = clamp(color.b, 0.0, 1.0);

    vec3 gradientColor = gradientX;
    gradientColor = mix(gradientColor, gradientY, color.g);
    gradientColor = mix(gradientColor, gradientZ, color.b);

    vec2 uvRandom = vUv;
    float amount = 1.0;
    uvRandom.y *= random(vec2(uvRandom.y,amount) + (time * 0.000001));
    float noise = random(uvRandom)*0.15;
    vec3 noiseColor = vec3(noise, noise, noise);
    gradientColor.rgb += noiseColor;

    gradientColor = mix(vec3(1), gradientColor, 0.5);

    gl_FragColor = vec4(mix(vec3(1), gradientColor, transition), 1.0);
  }
`;
